import { t } from '../i18n/pt';
import { extractPtDigits } from './phone';

export type Validator = (value: string) => string | null;

export const required: Validator = (value) =>
  value.trim().length === 0 ? t.validation.required : null;

export const email: Validator = (value) => {
  if (value.trim().length === 0) return null;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? null : t.validation.email;
};

export const phonePT: Validator = (value) => {
  if (value.trim().length === 0) return null;
  return extractPtDigits(value).length === 9 ? null : t.validation.phone;
};

export const postalCodePT: Validator = (value) => {
  if (value.trim().length === 0) return null;
  return /^\d{4}-\d{3}$/.test(value) ? null : t.validation.postalCode;
};

export const nif: Validator = (value) => {
  if (value.trim().length === 0) return null;
  return /^\d{9}$/.test(value) ? null : t.validation.nif;
};

export function minLength(n: number): Validator {
  return (value) => {
    if (value.length === 0) return null;
    return value.length >= n
      ? null
      : t.validation.minLength.replace('{n}', String(n));
  };
}

export const password: Validator = (value) => {
  if (value.length === 0) return null;
  return value.length >= 8 ? null : t.validation.passwordMin;
};

export function combine(...validators: Validator[]): Validator {
  return (value) => {
    for (const v of validators) {
      const err = v(value);
      if (err) return err;
    }
    return null;
  };
}

export function runValidators<K extends string>(
  rules: Partial<Record<K, Validator>>,
  values: Record<K, string>,
): Partial<Record<K, string>> {
  const errors: Partial<Record<K, string>> = {};
  for (const key in rules) {
    const validator = rules[key];
    if (!validator) continue;
    const err = validator(values[key] ?? '');
    if (err) errors[key] = err;
  }
  return errors;
}
